<template>
  <ToggleButton
    v-tooltip.right="{
      value: sendCompletionEmail ? 'Disable Draw Complete Emails' : 'Enable Draw Complete Emails',
      pt: {
        text: 'whitespace-nowrap w-fit',
      },
    }"
    v-model="sendCompletionEmail"
    class="h-6 w-13"
    :class="sendCompletionEmail ? 'bg-success-100' : ''"
    on-icon="pi pi-envelope"
    off-icon="pi pi-envelope"
    on-label=""
    off-label=""
    @change="$emit('change')"
  ></ToggleButton>
</template>

<script setup lang="ts">
const sendCompletionEmail = defineModel<boolean>();

const emit = defineEmits<{
  change: [];
}>();
</script>
